import styled from "react-emotion";

export const MessageGroupBase = styled.div`
  padding-top: 17px;
`



// WEBPACK FOOTER //
// ./src/ui/Messages/elements.ts